var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticStyle:{"white-space":"pre"},domProps:{"textContent":_vm._s(_vm.title)}})}
var staticRenderFns = []

export { render, staticRenderFns }